import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-employee-profile',
  templateUrl: './employee-profile.component.html',
  styleUrls: ['./employee-profile.component.scss'],
})
export class EmployeeProfileComponent implements OnInit {
  @Input() employee: any;
  @Input() imageSrc: string;

  constructor() {}

  ngOnInit(): void {}

  getBorderColor() {
    return `6px solid ${this.employee?.employeeTitle?.color}`;
  }
}
